import { useQuery } from 'react-query';
import DocumentsAPI from 'services/API/DocumentsAPI';

export const useDocumentDetails = <T>(uuid: string | null) => {
  const combinedCall = useQuery<T>(['documentDetails', uuid], async () => {
    const [detailsResult, activitiesResult, companiesResult] = await Promise.all([
      DocumentsAPI.getDocumentDetailsV3(uuid!),
      DocumentsAPI.getDocumentActivitiesV3(uuid!),
      DocumentsAPI.getDocumentCompaniesV3(uuid!),
    ]);

    return {
      ...detailsResult.data,
      activities: activitiesResult.data,
      companies: companiesResult.data,
    } as T;
  });

  return combinedCall;
};

export const useDocumentDetailsV4 = <T>(documentId: string | null) => {
  const combinedCall = useQuery<T>(
    ['documentDetailsV4', documentId],
    async () => {
      const [detailsResult, activitiesResult, companiesResult] = await Promise.all([
        DocumentsAPI.getDocumentDetailsV4(documentId!),
        DocumentsAPI.getDocumentActivitiesV4(documentId!),
        DocumentsAPI.getDocumentCompaniesV4(documentId!),
      ]);

      return {
        ...detailsResult.data,
        activities: activitiesResult.data,
        companies: companiesResult.data,
      } as T;
    },
    {
      refetchOnWindowFocus: false,
    },
  );

  return combinedCall;
};
